import React, {FC} from "react"

import Card from "@irati/ui/src/Layout/Card"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import {Hr} from "@irati/ui/src/Layout"
import {Body} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"

import Header from "../Detail/Header"
import customRewardImage from "../../images/customReward.png"

interface Props extends InjectIntl {}

const Detail: FC<Props> = ({formatMessage}) => {
  const theme = useTheme()

  return (
    <Card large>
      <Header title={formatMessage({id: "reward.customReward.title"})} thumbnailImage={customRewardImage} />
      <Hr large />
      <Body small marginBottom={1}>
        <FormattedMessage id="reward.customReward.detail.description" />
      </Body>
      <Body small marginBottom={1} marginTop={3} color={theme.colors.greys.mediumDark}>
        <FormattedMessage id="reward.fields.reward.customReward.Hint" />
      </Body>
    </Card>
  )
}

export default injectIntl(Detail)
